import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { Spacer } from "@Components/Space"
import { baseColors } from "@Constants/baseStyles"
import React, { useEffect, useState } from "react"
import { Dimensions, StyleSheet, TouchableOpacity, View, ViewBase } from "react-native"
import { Divider, RadioButton } from "react-native-paper"
import { handleSetRadioResponsesPayload } from "./QuestionLogic"

const { width } = Dimensions.get("screen")

export const QuestionYesOrNoWithoutSteps = (props) => {
    const { question, responses, setPayload, questionId, isResult, userResponse, questionNumber } = props
    const [value, setValue] = useState(0)
    const getResponseId = (response) => {
        const res = responses?.find((item) => item?.textResponse?.toLowerCase() === response)
        return res?.id
    }
    const handleSetValue = (choosedResponse) => () => {
        // const response = choosedResponse === 1 ? "oui" : "non"
        handleSetRadioResponsesPayload(questionId, choosedResponse, setPayload)
        setValue(choosedResponse)
    }
    const correctAnswer = responses.find((item) => item?.id === userResponse?.correctResponse?.[0])
    // const userAnswer = responses.find(
    //     (item) => item?.id === userResponse?.userResponse[userResponse?.userResponse?.length - 1]
    // )

    useEffect(() => {
        if (isResult) {
            setValue(userResponse?.userResponse?.[0])
        } else {
            setValue(null)
        }
    }, [userResponse, isResult])

    return (
        <View style={{ marginBottom: 50 }}>
            <OpenSansText fontWeight="bold" color={baseColors.orange.primary}>{`QUESTION N° ${
                questionNumber ?? 1
            }`}</OpenSansText>

            <OpenSansText style={{ marginTop: 10 }} fontSize={16}>
                {question ?? "Actuellement, pratiquez-vous une activité physique ?"}
            </OpenSansText>

            <Spacer height={20} />

            <View style={styles.radioGroupContainer}>
                {responses?.map((response) => (
                    <View>
                        <TouchableOpacity style={{}} onPress={handleSetValue(response?.id)}>
                            <View style={{ flexDirection: "row", alignItems: "center" }}>
                                <RadioButton
                                    disabled={isResult}
                                    color={baseColors.orange.dark}
                                    onPress={handleSetValue(response?.id)}
                                    status={value === response?.id ? "checked" : "unchecked"}
                                />
                                <OpenSansText fontSize={14}>{response?.textResponse}</OpenSansText>
                            </View>
                        </TouchableOpacity>

                        <Divider style={{ backgroundColor: baseColors.green.pastel, marginVertical: 10 }} />
                    </View>
                ))}

                {/* 
                <TouchableOpacity style={{ marginLeft: 40 }} onPress={handleSetValue(0)}>
                    <View style={{ flexDirection: "row", alignItems: "center" }}>
                        <RadioButton
                            color={baseColors.orange.dark}
                            onPress={handleSetValue(0)}
                            status={value === 0 ? "checked" : "unchecked"}
                        />
                        <OpenSansText fontSize={16}>Non</OpenSansText>
                    </View>
                </TouchableOpacity> */}
            </View>

            {isResult && (
                <View style={{ flexDirection: "row", marginTop: 10 }}>
                    <OpenSansText style={{ fontStyle: "italic", color: "green", fontWeight: "bold" }} fontSize={14}>
                        La bonne réponse :
                    </OpenSansText>

                    <OpenSansText style={{ fontStyle: "italic", marginLeft: 10 }} fontSize={14}>
                        {correctAnswer?.textResponse}
                    </OpenSansText>
                </View>
            )}
        </View>
    )
}

const styles = StyleSheet.create({
    radioGroupContainer: { flexDirection: "column", justifyContent: "space-between" }
})
